var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-group"},_vm._l((_vm.items),function(item,index){return _c('selection-button',_vm._b({key:item.title,attrs:{"selected":index === _vm.selectedIndex},on:{"select":function($event){return _vm.onSelect(index)}}},'selection-button',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }